export default "__VITE_ASSET__Bn$m6Yoe__"